import React from "react"

interface LoaderProps {
  size?: "small" | ""
  color?: "primary" | "" | "secondary"
}

function Loader({ size = "", color = "primary" }: LoaderProps) {
  return (
    <div className="d-flex align-center justify-center py-5">
      <div className={`loader ${size} ${color}`}>
        <div className={`inner-loader ${color}`} />
      </div>
    </div>
  )
}

export default Loader
